export default "__VITE_ASSET__iablVaVw__"